import { type Theme } from '@mint-lib/styled';

//// Style helpers
export const getBorder = (
  theme: Theme,
  isDisabled: boolean,
  isFocused: boolean,
  error?: boolean,
  warning?: boolean,
) => {
  if (error) {
    return `2px solid ${theme.palette.error.main}`;
  }
  if (warning) {
    return `2px solid ${theme.palette.warning.main}`;
  }
  if (isDisabled) {
    return `1px solid ${theme.palette.border.disabled}`;
  }
  if (isFocused) {
    return `2px solid ${theme.palette.action.focusBorder}`;
  }
  return `1px solid ${theme.palette.border.primary}`;
};

export const getBoxBorderWithHover = (
  isFocused: boolean,
  isDisabled: boolean,
  isReadOnlyAccess: boolean,
  theme: Theme,
) => {
  if (isFocused) {
    return `2px solid ${theme.palette.action.focusBorder}`;
  }
  if (isDisabled) {
    return `1px solid ${theme.palette.border.disabled}`;
  }
  if (isReadOnlyAccess) {
    return `1px solid ${theme.palette.border.primary}`;
  }

  return `1px solid ${theme.palette.action.focusBorder}`;
};
export const getValueTextColor = (
  isDisabled: boolean,
  isReadOnlyAccess: boolean,
  theme: Theme,
) => {
  if (isDisabled) {
    return theme.palette.action.disabled01;
  }
  if (isReadOnlyAccess) {
    return theme.palette.text.secondary;
  }
  return theme.palette.text.primary;
};

export const getBgColor = (
  isDisabled: boolean,
  isReadOnlyAccess: boolean,
  theme: Theme,
) => {
  if (isDisabled) {
    return theme.palette.action.disabledBackground;
  }
  if (isReadOnlyAccess) {
    return theme.palette.ui.field01;
  }
  return theme.palette.background.paper;
};
